import { Box, Grid, Icon } from "@mui/material";
import React, { useEffect, useState } from "react";
import CoreButton from "../../core/inputs/CoreButton";
import { useDispatch, useSelector } from "react-redux";
import CoreIFrame from "../../core/dataDisplay/CoreIFrame";
import {
  downloadInvoiceFile,
  downloadPriceBookExcel,
  setBillReducer,
} from "../../store/actions/billActions";
import CompareInvoiceCard from "./CompareInvoiceCard";
import { useLocation } from "react-router";
import { camelToSentenceCase, mapExpenseTypes } from "../../helper/utils";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import TenderPartsTable from "./TenderPartsTable";

export default function SingleDraftDoc() {
  const dispatch = useDispatch();
  const location = useLocation();
  const pathname = location.pathname;

  const document = useSelector((state) => state.bill?.billUploadData);
  const invoiceFileUrl = useSelector((state) => state?.bill?.invoiceFileUrl);
  const category = useSelector((state) => state?.common?.expenseTypes);

  const [filters, setFilters] = useState([]);
  const [fileType, setFileType] = useState(null);
  const [detailFlag, setDetailFlag] = useState(null);
  const [imageStyle, setImageStyle] = useState(null);
  const [docId, setDocId] = useState(null);

  useEffect(() => {
    return () => {
      dispatch(
        setBillReducer({
          docUpdateSuccess: false,
          docUpdateError: false,
          document: null,
          submitBillSuccess: false,
          submitBillError: false,
          submitBillMessage: false,
        }),
      );
    };
  }, []);

  useEffect(() => {
    if (document && docId) {
      dispatch(downloadInvoiceFile(docId, "pdf"));
      setFileType("pdf");
    }
  }, [document, docId]);

  useEffect(() => {
    if (document) {
      setDocId(document.tempDocId);
    }
  }, [document]);

  useEffect(() => {
    if (category && category[0]) {
      let expenseTypes = category[0].Children;
      expenseTypes = mapExpenseTypes(expenseTypes);
      setFilters([
        { id: 1, icon: "calendar", value: "daily", label: " Daily" },
        { id: 2, icon: "calendar", value: "monthly", label: " Monthly" },
        ...expenseTypes,
      ]);
    }
  }, [category]);

  useEffect(() => {
    if (invoiceFileUrl) {
      var img = new Image();
      img.onload = function () {
        var height = img.height;
        var width = img.width;
        // code here to use the dimensions
        if (height > width) {
          setImageStyle({ height: "100%", maxHeight: "100%" });
        } else {
          setImageStyle({ width: "100%" });
        }
      };

      img.src = invoiceFileUrl;
    }
  }, [invoiceFileUrl]);

  const downloadPriceBook = () => {
    dispatch(downloadPriceBookExcel(document));
  };

  // console.log(fileType);
  console.log(filters, document, docId);
  // console.log("invoiceFileUrl", invoiceFileUrl);

  return (
    <Box style={{ height: "100%", width: "100%" }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={5}>
          <CompareInvoiceCard>
            <CoreIconButton
              disabled={!docId}
              onClick={() => {
                dispatch(downloadInvoiceFile(docId, "pdf", false));
                setFileType("pdf");
              }}
              style={{
                backgroundColor: "white",
                position: "absolute",
                top: 80,
                opacity: 0.8,
              }}
            >
              <Icon>download</Icon>
            </CoreIconButton>
            {fileType === "image" ? (
              imageStyle && (
                <div
                  id="image-viewer"
                  style={{
                    display: "flex",
                    height: "100%",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    style={imageStyle}
                    src={invoiceFileUrl}
                    alt="Loading ..."
                  />
                </div>
              )
            ) : fileType === "pdf" ? (
              <CoreIFrame
                src={invoiceFileUrl}
                style={{
                  height: "100%",
                  minHeight: "100%",
                  width: "100%",
                  minWidth: "100%",
                  // "-moz-transform": "scale(0.5)",
                }}
              />
            ) : null}
          </CompareInvoiceCard>
        </Grid>
        <Grid item xs={12} sm={7} style={{ height: "100%", width: "100%" }}>
          <CompareInvoiceCard>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              {pathname?.includes("pricebook") ? (
                <CoreIconButton onClick={downloadPriceBook}>
                  <Icon>download</Icon>
                </CoreIconButton>
              ) : null}
              <CoreButton
                variant="text"
                onClick={() => {
                  setDetailFlag(!detailFlag);
                }}
              >
                {detailFlag && <Icon>chevron_left</Icon>}
                {!detailFlag ? "More " : "Less"}
                {!detailFlag && <Icon>chevron_right</Icon>}
              </CoreButton>
            </div>
            <Box
              style={{
                minHeight: detailFlag ? "100%" : "90%",
                maxHeight: detailFlag ? "100%" : "90%",
                overflowY: "auto",
                padding: 12,
              }}
            >
              {!detailFlag ? (
                <Grid container spacing={2}>
                  {Object.keys(document)
                    .filter(
                      (field) =>
                        !Array.isArray(document[field]) &&
                        field !== "tempDocId",
                    )
                    .map((field) => (
                      <Grid item xs={6}>
                        <div>
                          <p>
                            <strong>{camelToSentenceCase(field)}</strong>
                          </p>
                          <p>
                            {document[field] === "0"
                              ? "No"
                              : document[field] === "1"
                                ? "Yes"
                                : document[field]}
                          </p>
                        </div>
                      </Grid>
                    ))}
                </Grid>
              ) : (
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    {Object.keys(document)
                      .filter((field) => Array.isArray(document[field]))
                      .map((field) => (
                        <div>
                          <p>
                            <strong>{camelToSentenceCase(field)}</strong>
                          </p>
                          <TenderPartsTable id={field} rows={document[field]} />
                        </div>
                      ))}
                  </Grid>
                </Grid>
              )}
            </Box>
          </CompareInvoiceCard>
        </Grid>
      </Grid>
    </Box>
  );
}
